import { render, staticRenderFns } from "./FichaA4.vue?vue&type=template&id=372d593d&scoped=true&"
import script from "./FichaA4.vue?vue&type=script&lang=js&"
export * from "./FichaA4.vue?vue&type=script&lang=js&"
import style0 from "./FichaA4.vue?vue&type=style&index=0&id=372d593d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d593d",
  null
  
)

export default component.exports